import React from "react";
import { EstudiosGloabl } from "./styled";

export const Estudio = () => {
  return (
    <>
      <EstudiosGloabl>ESTUDIOS</EstudiosGloabl>
    </>
  );
};
